export const WHEN = 'pdp.date_selection.when';
export const TODAY = 'pdp.date_selection.today';
export const TOMORROW = 'pdp.date_selection.tomorrow';
export const DATE_PICKER = 'pdp.date_selection.date_picker';
